import styled from 'styled-components'
import { drawStroke, bounce } from '../animate'

export const InfoStyled = styled.svg`
  .stroke {
    stroke: ${props => props.theme};
  }
  .fill {
    fill: ${props => props.theme};
  }
  &.is-animated {
    &:hover {
      .draw-stroke-path {
        stroke-dasharray: 100;
        stroke-dashoffset: 100;
        animation: ${drawStroke} 1s linear forwards;
      }
      .stroke-path-2,
      .stroke-path-3 {
        animation: ${bounce} 1s linear forwards;
      }
    }
  }
`
